<script setup lang="ts">
type ResponsiveType = '2x' | '3x'

const props = defineProps<{
  src: string
  responsive: ResponsiveType | ResponsiveType[]
}>()

function getSrcSet(src: string, size: string) {
  return `${src.replace(/(\.[\w\d_-]+)$/i, `@${size}$1`)} ${size}`
}

const srcSet = computed(() => {
  if (!props.responsive) return
  let srcSet = ''

  if (Array.isArray(props.responsive)) {
    props.responsive.forEach((size) => {
      srcSet += getSrcSet(props.src, size)
    })
  } else {
    srcSet = getSrcSet(props.src, props.responsive)
  }

  return srcSet
})
</script>

<template>
  <img v-bind="$attrs" :src="src" :srcset="srcSet" />
</template>
